module.exports = __webpack_public_path__ + "static/media/hezuohuoban.60a3bc7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/hezuohuoban.png
// module id = 518
// module chunks = 0